import React from 'react';
import { Context } from '../model/Elements';

const CustomContext: React.Context<Context> = React.createContext({
    updateAuth: () => {},
});
export default CustomContext;
